// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/store.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from message omnios.v1.PortalInstance
 */
export const PortalInstance = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PortalInstance",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "active_session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "preview_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "store_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "custom_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "logo_media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "portal_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "portal_type_config", kind: "message", T: Struct },
    { no: 15, name: "metadata", kind: "message", T: Struct },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
    { no: 32, name: "published_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.StoreConfig
 */
export const StoreConfig = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StoreConfig",
  () => [
    { no: 13, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "store_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "store_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "logo_media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "tax_inclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "tax_rate_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "checkout_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "inventory_tracking", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "auto_fulfill", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "metadata", kind: "message", T: Struct },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.StorePolicy
 */
export const StorePolicy = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StorePolicy",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "content_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 30, name: "created_at", kind: "message", T: Timestamp },
    { no: 31, name: "updated_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Public-facing store info (for portal instances)
 *
 * @generated from message omnios.v1.PublicStoreInfo
 */
export const PublicStoreInfo = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublicStoreInfo",
  () => [
    { no: 1, name: "store_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "store_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "logo_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "tax_inclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "checkout_mode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "payment_methods", kind: "message", T: PublicPaymentMethod, repeated: true },
    { no: 11, name: "delivery_methods", kind: "message", T: PublicDeliveryMethod, repeated: true },
    { no: 12, name: "policies", kind: "message", T: StorePolicy, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.PublicPaymentMethod
 */
export const PublicPaymentMethod = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublicPaymentMethod",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "supported_currencies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.PublicDeliveryMethod
 */
export const PublicDeliveryMethod = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublicDeliveryMethod",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "provider_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "supported_countries", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.CreatePortalInstanceRequest
 */
export const CreatePortalInstanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePortalInstanceRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "template_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "auto_start_agent", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "portal_type_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RefreshRecommendationsRequest
 */
export const RefreshRecommendationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RefreshRecommendationsRequest",
  () => [
    { no: 1, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RefreshRecommendationsResponse
 */
export const RefreshRecommendationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RefreshRecommendationsResponse",
  () => [
    { no: 1, name: "ok", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.CreatePortalInstanceResponse
 */
export const CreatePortalInstanceResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePortalInstanceResponse",
  () => [
    { no: 1, name: "portal_instance", kind: "message", T: PortalInstance },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.GetPortalInstanceRequest
 */
export const GetPortalInstanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPortalInstanceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPortalInstancesRequest
 */
export const ListPortalInstancesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPortalInstancesRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPortalInstancesResponse
 */
export const ListPortalInstancesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPortalInstancesResponse",
  () => [
    { no: 1, name: "portal_instances", kind: "message", T: PortalInstance, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePortalInstanceRequest
 */
export const UpdatePortalInstanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePortalInstanceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "store_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "custom_domain", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "logo_media_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 15, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.DeletePortalInstanceRequest
 */
export const DeletePortalInstanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePortalInstanceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PublishPortalInstanceRequest
 */
export const PublishPortalInstanceRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PublishPortalInstanceRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.PortalKey
 */
export const PortalKey = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.PortalKey",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "portal_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "allowed_origins", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "rate_limit_rpm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "expires_at", kind: "message", T: Timestamp },
    { no: 11, name: "last_used_at", kind: "message", T: Timestamp },
    { no: 12, name: "revoked_at", kind: "message", T: Timestamp },
    { no: 13, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.CreatePortalKeyRequest
 */
export const CreatePortalKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePortalKeyRequest",
  () => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "portal_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "scopes", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 6, name: "allowed_origins", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "rate_limit_rpm", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "expires_in_days", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreatePortalKeyResponse
 */
export const CreatePortalKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePortalKeyResponse",
  () => [
    { no: 1, name: "key", kind: "message", T: PortalKey },
    { no: 2, name: "plaintext", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPortalKeysRequest
 */
export const ListPortalKeysRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPortalKeysRequest",
  [],
);

/**
 * @generated from message omnios.v1.ListPortalKeysResponse
 */
export const ListPortalKeysResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPortalKeysResponse",
  () => [
    { no: 1, name: "keys", kind: "message", T: PortalKey, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.RevokePortalKeyRequest
 */
export const RevokePortalKeyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokePortalKeyRequest",
  () => [
    { no: 1, name: "key_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.RevokePortalKeyResponse
 */
export const RevokePortalKeyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.RevokePortalKeyResponse",
  [],
);

/**
 * @generated from message omnios.v1.GetStoreConfigRequest
 */
export const GetStoreConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetStoreConfigRequest",
  () => [
    { no: 1, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateStoreConfigRequest
 */
export const UpdateStoreConfigRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateStoreConfigRequest",
  () => [
    { no: 12, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "store_name", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "store_url", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "logo_media_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "tax_inclusive", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 7, name: "tax_rate_pct", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, opt: true },
    { no: 8, name: "checkout_mode", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 9, name: "inventory_tracking", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 10, name: "auto_fulfill", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 11, name: "metadata", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.CreatePolicyRequest
 */
export const CreatePolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreatePolicyRequest",
  () => [
    { no: 5, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "content_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdatePolicyRequest
 */
export const UpdatePolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdatePolicyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "content_html", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 5, name: "sort_order", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeletePolicyRequest
 */
export const DeletePolicyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeletePolicyRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPoliciesRequest
 */
export const ListPoliciesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPoliciesRequest",
  () => [
    { no: 2, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "active_only", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message omnios.v1.ListPoliciesResponse
 */
export const ListPoliciesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListPoliciesResponse",
  () => [
    { no: 1, name: "policies", kind: "message", T: StorePolicy, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.GetPublicStoreInfoRequest
 */
export const GetPublicStoreInfoRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetPublicStoreInfoRequest",
  () => [
    { no: 1, name: "portal_instance_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

